import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_USER_MANAGEMENT;
const API_HRMS_EMPLOYEE_URL = process.env.REACT_APP_HRMS_EMPLOYEE_URL
const API_CHILD_UNITS = process.env.REACT_APP_CHILD_UNITS
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const api2 = axios.create({
  baseURL: API_HRMS_EMPLOYEE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const api3 = axios.create({
  baseURL: API_CHILD_UNITS,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});


// Add an interceptor to attach the token dynamically
const attachToken = (config) => {
  const accessToken = sessionStorage.getItem("accessToken");
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  return config;
};



api.interceptors.request.use(attachToken, (error) => Promise.reject(error));
api2.interceptors.request.use(attachToken, (error) => Promise.reject(error));
api3.interceptors.request.use(attachToken, (error) => Promise.reject(error));
export const getProsecutorListByAdminUnitAndOrgUnit = (admin_id, org_id) => api.get(`prosecutor-list/fetch_employees_by_admin_unit_org_org/?admin_id=${admin_id}&org_id=${org_id}`)
export const getProsecutorDetailByEmployeeId = (employee_id) => api.get(`users/user_detail/${employee_id}/`)
export const getChildsByParent = (id) => api3.get(`${id}/`)